module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"exportTitle":"Export","confirmMessage":"Do you want to export {reportType} Report as a Word document?","download":"Download"},"de":{"exportTitle":"Exportieren","confirmMessage":"Möchten Sie den {reportType}-Bericht als Word-Dokument exportieren?","download":"Herunterladen"}}')
  delete Component.options._Ctor
}
